import React from 'react';
import { observer } from 'mobx-react';

const Confirm = observer(class Confirm extends React.Component {
  constructor() {
    super();
    this.closeDialog = this.closeDialog.bind(this);
    this.confirmDialog = this.confirmDialog.bind(this);
  }

  componentDidMount() {
    document.addEventListener('keydown', this.confirmDialog, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.confirmDialog, false);
  }

  closeDialog(e) {
    e.preventDefault();
    this.props.store.SessionStore.closeDialog();
  }

  confirmDialog(e) {
    if(e) {
      e.preventDefault();
    }

    if(e.keyCode === 13) {
      this.props.store.SessionStore.confirmFunc();
    } else if(e.keyCode === 27) {
      this.closeDialog(e);
    } else if (typeof e.keyCode === 'undefined') {
      this.props.store.SessionStore.confirmFunc();
    }
  }

  render() {
    const { SessionStore } = this.props.store;

    return(
      <div className="dialog dialog--confirm">
        <div className="dialog__content">
          <strong className="dialog__msg">{SessionStore.confirmContent.heading}</strong>

          <p>{SessionStore.confirmContent.body}</p>

          <div className="dialog__btns">
            <a href="#app" className="btn btn--outline" onClick={(e) => this.closeDialog(e)}>Cancel</a>
            <a href="#app" className="btn" onClick={(e) => this.confirmDialog(e)}>{SessionStore.confirmContent.button}</a>
          </div>
        </div>
      </div>
    );
  }
})

export default Confirm;


// WEBPACK FOOTER //
// ./src/app/components/Common/Confirm.js